import React from "react";
import { SovosButton } from "mosaic-react";
import { AddCircleOutline } from "mosaic-react-icons";
import { UserRoles } from "../../enums/userRoles";
import { checkRolesByOrganizationProject } from "colbi_web_ui/lib/utils/roleValidator";

const RepositoryGeneratorFormButton = (props) => {
    const { pushModal, i18n, reload, projectId, user, endPointToRequest = undefined } = props;
    return (
        <>
            {checkRolesByOrganizationProject(user, projectId, [
                UserRoles.ADMIN,
                UserRoles.OWNER,
                UserRoles.WRITER,
                UserRoles.PP_SUPPORT,
                UserRoles.SUPPORT,
            ]) ? (
                <>
                    <SovosButton
                        disabled={false}
                        key="generateFiles"
                        children={i18n`Create new File`}
                        startIcon={<AddCircleOutline />}
                        onClick={() => {
                            pushModal({
                                title: "Create File",
                                data: {
                                    projectId: projectId,
                                    endPointToRequest: endPointToRequest,
                                },
                                args: { projectId: projectId },
                                view: "GenericGeneratorForm",
                                customHeaderButtonNames: { save: "Create" },
                            })
                                .then(() => {
                                    reload && reload();
                                })
                                .catch(() => null);
                        }}
                    />
                </>
            ) : null}
        </>
    );
};

export default RepositoryGeneratorFormButton;
